import { Badge } from "@chakra-ui/react";

const BadgeFormFilingMethod = ({ online }) => {
    let color = "gray"
    let text = "ไม่ระบุ"

    if (online) {
        color = "blue"
        text = "ยื่นออนไลน์"
    } else {
        color = "yellow"
        text = "ยื่นกระดาษ"
    }

    return (
        <Badge colorScheme={color}>{text}</Badge>
    )
}

export default BadgeFormFilingMethod